import { z } from "zod";

export const resolveReceiptCostBody = z.object({
  retainedDocumentId: z.string().uuid().optional(),
  importedCostEntryId: z.string().regex(/^[1-9][0-9]*$/).optional(),
  reason: z.string().trim().min(1).max(900),
  idempotencyKey: z.string().min(1).max(200),
}).strict().refine(b => (b.retainedDocumentId === undefined) !== (b.importedCostEntryId === undefined), {
  message: "Choose the counted receipt or the imported cost this receipt replaces.",
});
export type ResolveReceiptCostBody = z.infer<typeof resolveReceiptCostBody>;
export interface ReceiptCostOptions {
  imports: Array<{ costEntryId: string; amount: string; currency: string; label: string }>;
  receipts: Array<{ documentId: string; fileName: string; amount: string | null; currency: string | null; recordsOnly: boolean; posted: boolean }>;
  resolutions: Array<{ documentId: string; kind: "records_only" | "replaces_import"; reason: string; retainedDocumentId: string | null; importedCostEntryId: string | null }>;
}
